var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.650391 4.0001C0.650391 2.2604 2.06069 0.850098 3.80039 0.850098H18.2004C19.9401 0.850098 21.3504 2.2604 21.3504 4.0001V12.4001C21.3504 14.1398 19.9401 15.5501 18.2004 15.5501H11.7504V17.6501H14.6004C15.0146 17.6501 15.3504 17.9859 15.3504 18.4001C15.3504 18.8143 15.0146 19.1501 14.6004 19.1501H7.40039C6.98618 19.1501 6.65039 18.8143 6.65039 18.4001C6.65039 17.9859 6.98618 17.6501 7.40039 17.6501H10.2504V15.5501H3.80039C2.06069 15.5501 0.650391 14.1398 0.650391 12.4001V4.0001ZM18.2004 14.0501C19.1117 14.0501 19.8504 13.3114 19.8504 12.4001V4.0001C19.8504 3.08883 19.1117 2.3501 18.2004 2.3501H3.80039C2.88912 2.3501 2.15039 3.08883 2.15039 4.0001V12.4001C2.15039 13.3114 2.88912 14.0501 3.80039 14.0501H18.2004Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.ceeb5602ee503c74feb179bc3dc7c8ee.svg";
export { ForwardRef as ReactComponent };